import { useMutation, useQueryClient } from '@tanstack/react-query'

import { WBDApi } from '@/open-api'
import { StorageKeys } from '@/utils/constants'

const entity = 'auth'

export const useLogin = () => {
  const client = useQueryClient()

  const {
    mutate: login,
    error,
    isPending
  } = useMutation({
    mutationFn: (email: string) =>
      WBDApi.auth.authControllerLogin({ email }).then(({ data }) => data),
    onSuccess: () => client.invalidateQueries({ queryKey: [entity] })
  })

  return { login, isPending, error }
}

export const useVerification = () => {
  const client = useQueryClient()

  const {
    mutate: verify,
    error,
    isPending,
    isSuccess,
    data
  } = useMutation({
    mutationFn: ({ email, code }: { email: string; code: string }) =>
      WBDApi.auth.authControllerVerify({ email, code }).then(({ data }) => data),
    onSuccess: (data) => {
      const { accessToken } = data
      client.invalidateQueries({ queryKey: [entity] })
      localStorage.setItem(StorageKeys.ACCESS_TOKEN, accessToken)
      window.location.href = '/onboarding'
    }
  })

  return { verify, isPending, isSuccess, error, data }
}

export const logout = () => {
  localStorage.removeItem(StorageKeys.ACCESS_TOKEN)
  localStorage.removeItem(StorageKeys.BRAND_ANALYSIS)
  window.location.href = '/'
}
